import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useNavigate, useParams } from "react-router-dom";
import { TemplatesProvider } from "./context/templatesContext";
import { Templates } from "./Templates";

type Props = {};

const TemplatesPage = (props: Props) => {
	const { AssetIdParam } = useParams();
	const navigate = useNavigate();

	const {
		state: { defaultAreaId },
	} = useUserContext();

	if (!AssetIdParam) {
		navigate(`/templates/${defaultAreaId}`);
	}

	return (
		<>
			<HelmetDexteel title="Templates" />
			<TemplatesProvider>
				<Templates />
			</TemplatesProvider>
		</>
	);
};

export default TemplatesPage;
